import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {useNewsletterDictionary} from 'src/hooks/dictionaries/useNewsletterDictionary';

import {
    userSearchResultNewslettersDataSelector,
    userSearchResultNewslettersResultSelector,
} from '../../slices/user-search-result-newsletters.slice';

type Props = {
    userId: number,
};

export const NewslettersCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultNewslettersDataSelector);
    const result = useSelector(userSearchResultNewslettersResultSelector);

    const {newsletterLabels} = useNewsletterDictionary();

    const newsletters = useMemo(
        () => result?.data[userId],
        [result, userId],
    );

    if (isLoading || loadingError || !newsletters) {
        return null;
    }

    return (
        <span>
            {newsletters.length
                ? newsletters.map(newsletter => newsletterLabels[newsletter]).join('; ')
                : 'No Newsletter'}
        </span>
    );
};
